export default __webpack_public_path__ + "static/media/pen.c48d92a9.svg";